export const TIME_SERIES_LIST_COLUMN_TYPE = {
  DATE: 'DATE',
  TOTAL_HOURS_WORKED_TO_DATE: 'TOTAL_HOURS_WORKED_TO_DATE',
  ESTIMATED_REMAINING_HOURS: 'ESTIMATED_REMAINING_HOURS',
  ESTIMATED_HOURS_AT_COMPLETION: 'ESTIMATED_HOURS_AT_COMPLETION',
  ESTIMATED_COMPLETION_DATE: 'ESTIMATED_COMPLETION_DATE'
};
